import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import {createApp, watch} from 'vue'
import {createPinia} from 'pinia'
import i18next from 'i18next'
import I18NextVue from 'i18next-vue'
import './assets/main.css'
import CircleFlags from 'vue-circle-flags'
import 'vue-circle-flags/dist/vue-circle-flags.css'
import App from './App.vue'
import router from './router'
import {translations} from '@shared/translations'
import {applyThemeMode, isThemeMode, ThemeMode} from './lib/theme'
import {useLocalStore} from './stores/local'

const browserLanguage = navigator.language?.toLowerCase().startsWith('ru') ? 'ru' : 'en'

i18next.init({
  lng: browserLanguage,
  resources: translations,
})

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)

const localStore = useLocalStore()
const systemThemeQuery = window.matchMedia('(prefers-color-scheme: dark)')
const syncTheme = (): void => {
  const themeMode = isThemeMode(localStore.theme) ? localStore.theme : ThemeMode.System
  applyThemeMode(themeMode, systemThemeQuery.matches)
}

syncTheme()
watch(() => localStore.theme, syncTheme)
systemThemeQuery.addEventListener('change', syncTheme)

app.use(CircleFlags)
app.use(router)
app.use(I18NextVue, {i18next})

app.mount('#app')

if ('serviceWorker' in navigator) {
  const baseUrl = import.meta.env.BASE_URL || '/'
  const serviceWorkerUrl = new URL(`${baseUrl}sw.js`, window.location.origin)

  window.addEventListener('load', () => {
    void navigator.serviceWorker.register(serviceWorkerUrl, {
      scope: baseUrl,
    })
  })
}
